import React from "react";
import { FaStar } from "react-icons/fa";
import { useState } from "react";

const StarRating = ({ ratingEvent, totalStars }) => {
  const [rating, setRating] = useState(0);

  const handleClick = (rate) => {
    setRating(rate);
    if (ratingEvent) ratingEvent(rate);
  };
  return (
    <div className="flex-container gap-10">
      {Array.from({ length: totalStars }, (_, index) => {
        const starValue = index + 1;
        return (
          <FaStar
            key={starValue}
            size={50}
            onClick={() => handleClick(starValue)}
            style={{
              color: starValue <= rating ? "#e4e400" : "#dfdfdf",
              cursor: "pointer",
              transition: "color .2s ease",
              fontSize: "100px",
            }}
          ></FaStar>
        );
      })}
    </div>
  );
};

export default StarRating;
